import differenceInDays from "date-fns/differenceInDays";
import {
  endOfMonth,
  endOfQuarter,
  endOfYesterday,
  startOfMonth,
  startOfQuarter,
  subMonths,
  subQuarters,
  subWeeks,
  subYears,
} from "date-fns/esm";

import DateRange from "@app/scene/reports/types/DateRange";
import { getWeekEnd, getWeekStart } from "@app/util/dates";

const MAX_YEARS = 3;

export type DateRangeWithOffset = DateRange & { offset: number };

function* rangesGenerator(
  getStart: (date: Date) => Date,
  getEnd: (date: Date) => Date,
  sub: (date: Date, amount: number) => Date,
  fromDate: Date = subYears(Date.now(), MAX_YEARS)
): Generator<DateRangeWithOffset, void, never> {
  // since we can only get stat data for yesterday max, we start from there, not from today.
  let startDate = getStart(endOfYesterday());
  let offset = 0;
  while (differenceInDays(startDate, getStart(fromDate)) >= 0) {
    yield { endDate: getEnd(startDate), offset, startDate };
    startDate = sub(startDate, 1);
    offset--;
  }
}

export const weekRangesGenerator = (fromDate?: Date) =>
  rangesGenerator(getWeekStart, getWeekEnd, subWeeks, fromDate);
export const monthRangesGenerator = (fromDate?: Date) =>
  rangesGenerator(startOfMonth, endOfMonth, subMonths, fromDate);
export const quarterRangesGenerator = (fromDate?: Date) =>
  rangesGenerator(startOfQuarter, endOfQuarter, subQuarters, fromDate);

export default rangesGenerator;
